import { Observable, firstValueFrom, isObservable } from "rxjs";
declare const Zone: any;

export class Utility {
    /**
     * It make an array an array of pair
     * @param arr Array to pair
     * @returns [1,2,3,4,5] => [[1,2],[2,3],[3,4],[4,5]]
     */
    static toPairs<T>(arr: T[]): T[][] {
        const pairs: T[][] = [];
        for (let i = 0; i < arr.length - 1; i++) {
            pairs.push([arr[i], arr[i + 1]]);
        }
        return pairs;
    }

    static toPromise<T>(obj: Observable<T> | Promise<T>): Promise<T> {
        if (isObservable(obj)) {
            obj = firstValueFrom(obj);
        }
        const macroTask = Zone.current.scheduleMacroTask(
            `WAITFOR-${Math.random()}`,
            () => { },
            {},
            () => { }
        );
        return obj.then((p: T) => {
            macroTask.invoke();
            return p;
        });
    }

    
    /** generate a random string */
    public static RandomString(length: number): string {
        let result = '';
        const characters = 'YstuvwxMNOabcCPHIJK345defghijklmnQRSTUVWXyz01opqr92AB678ZLDEFG';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    
    /** For Data Utility. Return 01 instead of 1 */
    private static zeroBefore(val: string): string {
        return val.length === 1 ? `0${val}` : val;
    }

    /** Resituiscs la data formattata
     * dd: day | MM: month | yyyy: fullYear | h : hour | mm: minutes | ss : seconds | ml : milliseconds | tz : timezone
     */
    public static formatDate(date: Date, s = 'dd-MM-yyyy'): string {
        return s.replace('dd', this.zeroBefore(date.getDate().toString()))
            .replace('MM', this.zeroBefore((date.getMonth() + 1).toString()))
            .replace('yyyy', date.getFullYear().toString())
            .replace('h', this.zeroBefore(date.getHours().toString()))
            .replace('mm', this.zeroBefore(date.getMinutes().toString()))
            .replace('ss', this.zeroBefore(date.getSeconds().toString()))
            .replace('ml', this.zeroBefore(date.getMilliseconds().toString()))
            .replace('tz', date.getTimezoneOffset().toString());
    }
    
    /** gerate a random string with nice formatted now date  */
    public static RandomStringDateId(length: number, joiner = '_'): string {
        return [
            this.RandomString(length),
            this.formatDate(new Date(Date.now()), ['dd', 'MM', 'yyyy', 'h', 'mm', 'ss', 'ml'].join(joiner))
        ].join(joiner);
    }

}